import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiButton } from 'shell/components/shared/button';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import {
  ResearchTypeOperationVM,
  ResearchTypeOperationFilterVM,
} from 'practice/view-models/research-type-operation';
import ListTypePractice from 'practice/components/shared/list-type-practice';
import ListTypeDocument from 'shell/components/shared/list-type-document';
import ListYesNo from 'shell/components/shared/list-yes-no';

const FormFilter = (): React.ReactElement => {
  const formContext = useFormikContext<ResearchTypeOperationVM>();

  const onChange = useEventCallback(
    (
      key: keyof ResearchTypeOperationFilterVM,
      value: ResearchTypeOperationFilterVM[keyof ResearchTypeOperationFilterVM]
    ) => {
      formContext.setFieldValue('filter', {
        ...(formContext.values?.filter || {}),
        [key]: value,
      });
    }
  );

  const handleListTypePracticeChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typePractice', event.target.value);
  });

  const handleListTypeDocumentChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typeDocument', event.target.value);
  });

  const handleListInUseChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('inUse', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <ListTypePractice
          value={formContext.values?.filter?.typePractice || ''}
          onChange={handleListTypePracticeChange}
          error={
            (formContext.touched.filter as FormikTouched<ResearchTypeOperationFilterVM>)
              ?.typePractice &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchTypeOperationFilterVM>)
                ?.typePractice
            )
          }
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Codice tipo operazione"
          aria-label="Codice tipo operazione"
          fullWidth
          id="code"
          name="code"
          value={formContext.values.filter?.code || ''}
          onChange={(event) => onChange('code', event.target.value)}
          error={
            (formContext.touched.filter as FormikTouched<ResearchTypeOperationFilterVM>)?.code &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchTypeOperationFilterVM>)?.code
            )
          }
          helperText={
            (formContext.errors.filter as FormikErrors<ResearchTypeOperationFilterVM>)?.code
          }
          inputProps={{
            maxLength: '2',
          }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Descrizione tipo operazione"
          aria-label="Descrizione tipo operazione"
          fullWidth
          id="description"
          name="description"
          value={formContext.values.filter?.description || ''}
          onChange={(event) => onChange('description', event.target.value)}
          error={
            (formContext.touched.filter as FormikTouched<ResearchTypeOperationFilterVM>)
              ?.description &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchTypeOperationFilterVM>)
                ?.description
            )
          }
          helperText={
            (formContext.errors.filter as FormikErrors<ResearchTypeOperationFilterVM>)?.description
          }
          inputProps={{
            maxLength: '100',
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListTypeDocument
          value={formContext.values?.filter?.typeDocument || ''}
          onChange={handleListTypeDocumentChange}
          error={
            (formContext.touched.filter as FormikTouched<ResearchTypeOperationFilterVM>)
              ?.typeDocument &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchTypeOperationFilterVM>)
                ?.typeDocument
            )
          }
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListYesNo
          label="In uso"
          value={formContext.values?.filter?.inUse || ''}
          onChange={handleListInUseChange}
          error={
            (formContext.touched.filter as FormikTouched<ResearchTypeOperationFilterVM>)?.inUse &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchTypeOperationFilterVM>)?.inUse
            )
          }
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
        <Grid item xs={12} md={2}>
          <PmiButton variant="contained" color="secondary" fullWidth type="submit">
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Form Filter';

export default FormFilter;
